module.exports = __webpack_public_path__ + "static/img/zt-02.b8f37b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt-02.jpg
// module id = fmwv
// module chunks = 1